// @ts-expect-error ts-migrate(2305) FIXME: Module '"flux-actions"' has no exported member 'co... Remove this comment to see the full error message
import { handleActions, combineActions } from 'flux-actions';
import SecurityPhoneNumber from '../../records/security/SecurityPhoneNumber';
import { SecurityPhoneNumberActionTypes } from '../../actions/security/SecurityPhoneNumberActions';
const initialState = new SecurityPhoneNumber();
export default handleActions({
  [SecurityPhoneNumberActionTypes.FETCH_CONFIGURATION](state) {
    return state.merge(initialState);
  },
  [combineActions(SecurityPhoneNumberActionTypes.FETCH_CONFIGURATION_SUCCESSFUL, SecurityPhoneNumberActionTypes.CONFIGURE_SMS_SUCCESS, SecurityPhoneNumberActionTypes.CODE_ATTEMPT_SUCCESS)](state, action) {
    return state.merge(action.payload.securityPhoneNumber);
  },
  [SecurityPhoneNumberActionTypes.FETCH_CONFIGURATION_FAILED](state) {
    return state.merge(initialState);
  }
}, initialState);